export default (getText: (key: string, category: string) => string) => (key: string) =>
  ({
    minimize: getText('Minimize AV call', 'AVConsult_Video'),
  }[key])
